import React, { useEffect, useState } from "react";
import { Dialog, FormControl, InputLabel, MenuItem } from "@mui/material";
import { DialogContent, Stack, Select, TextField } from "@mui/material";
import { Divider, Button } from "@mui/material";
import { Toast } from "../../components/components/Toast";
import CustomInput from "../../components/components/CustomInput";
import Repo from "../../Repository/Repo";
import { ClipLoader } from "react-spinners";
import { Text } from "./AddCash";

function AddDeposit({ onClose, onSuccess, bank }) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  console.log('bankDeposit', bank);
  const [state, setState] = useState({
    amount: "",
    description: "",
    bankIdTo: "",
    depositTo: "",
    bankIdFrom: "",
    withdrawnFrom: "",
  });

  useEffect(() => {
    getBankRecords();
  }, []);

  const getBankRecords = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setRecords(data.response.data.banks);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = (arg) => {
    setState((prev) => ({ ...prev, [arg]: "" }));
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    try {
      if (!state.depositTo) {
        Toast("info", "Select bank to deposit");
        return;
      }
      if (!state.amount) {
        Toast("info", "Enter Amount to deposit");
        return;
      }
      let depositTo = JSON.parse(state.depositTo);

      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "bankToBankTransfer",
          data: {
            company_code: localStorage.getItem("companyCode"),
            amount: Number(state?.amount),
            from: bank?.bankName,
            bankIdFrom: bank?._id,
            bankIdTo: depositTo?._id,
            to: depositTo?.bankName,
            description: state?.description
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        Toast("success", "Deposited successfully");
      } else {
        Toast("error", data?.response?.data?.error || "Error");
      }
      onSuccess();
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const depositsBanks = () => {
    return records.filter((i) => i.bankName != "cashInHand");
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Stack width="100%">
            <Text>Transfer to Bank</Text>
            <Divider sx={{ mt: "16px", color: "#afafaf" }} />
          </Stack>
          <FormControl fullWidth size="small">
            <InputLabel>Deposit To</InputLabel>
            <Select
              size="small"
              name="depositTo"
              value={state.depositTo}
              label="Deposit To"
              onChange={handleInput}
            >
              {depositsBanks().map((item, i) => {
                return (
                  <MenuItem key={i} value={JSON.stringify(item)}>
                    {item.bankName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <CustomInput
            name="amount"
            label="Enter Amount"
            value={state.amount}
            onChange={handleInput}
            onClear={() => handleClear("amount")}
          />
          <TextField
            label="Description"
            multiline
            minRows={3}
            maxRows={6}
            name="description"
            type="number"
            value={state.description}
            onChange={handleInput}
          />

          {loading && (
            <Stack alignItems="center" width="100%" justifyContent="center">
              <ClipLoader size={32} loading={true} color="#4eaf51" />
            </Stack>
          )}
          {!loading && (
            <Stack direction="row" width="100%" justifyContent="space-evenly">
              <Button
                variant="contained"
                sx={{
                  background: "#F2F2F2 !important",
                  color: "#767676",
                  textTransform: "none",
                }}
                onClick={toggle}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={handleSubmit}
              >
                Transfer
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddDeposit;
